// removed by extract-text-webpack-plugin
module.exports = {"block":"_1kSmnujPlXneZIOO8GSe1T","inner":"lddjDK9WMOYmUs0LNzF1B","outer":"_2YdAiN112Hpa0Q_gtPW_Qp","shown":"_9yhSgFTRGqXafEUVKHeSp","icon":"_1M66zonMtQ4E06DhjFxwQd","tooltip":"_2g_wj9fCSieBZeDfNMDR6O","tooltipIcon":"_3HDSvH5NuH_24oXWCn9jul","large":"_3SDQL6xEtey9Jsbs5FB9uH","link":"_19WNlTaxQQld4A9wlergxY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CuriousBlock/CuriousBlock.module.scss
// module id = 745
// module chunks = 0